import React, { Component } from 'react';

// helpers
import AmplitudeHelperClass from '/src/utilities/amplitudeHelper';



const amplitudeHelper = new AmplitudeHelperClass();

export default class Slider extends Component {

    constructor(props) {
        super(props);
        this.state = {
            item: [],

            // slider
            limit: null,
            slider: null,
            itemSlider: [],
        };
    }

    amplitudeTrack(action) {
        amplitudeHelper.trackEvent(action);
    }

    initializeSlider = () => {
        const { displayCount } = this.props;
        const { item } = this.state;
        // const limit  = (displayCount * 3);               // 3 pages
        const limit  = item.length;
        const slider = { start: 0, end: (displayCount - 1)} // end = index of last displayed element in a slide
        this.setState({ limit, slider });
    }

    imgMissing(event) {
        if (!event?.target?.style && !event?.target?.parentNode?.style) return;

        event.target.style.opacity = 0;
        event.target.parentNode.style['border-radius'] = '7px';
        event.target.parentNode.style['background-color'] = '#F0F0F0';
        event.target.parentNode.style['width'] = '100%';
        event.target.parentNode.style['aspect-ratio'] = '1.33';
        event.target.parentNode.style['border-bottom-left-radius'] = '0';
        event.target.parentNode.style['border-bottom-right-radius'] = '0';
    }

    gtag = (label) => {
        window.gtag('event', 'click', {
            event_category: 'research',
            event_label: label,
        });
    };

    moveSlider = (type) => {
        this.setState({ fadeClass: "fade hide" }, () => {
            // fade effect
            setTimeout(() => {
                let itemSlider = [];
                const { item, slider } = this.state;
                const { displayCount } = this.props;
                let { start, end } = slider;

                if (type === "prev") {
                    this.amplitudeTrack("research - clicked slider");
                    start -= displayCount;
                    end   -= displayCount;
                } else if (type === "next") {
                    this.amplitudeTrack("research - clicked slider");
                    start += displayCount;
                    end   += displayCount;
                }
                // else reload initial

                for (let i in item) {
                    if ((i >= start) && (i <= end)) {
                        itemSlider.push(item[i])
                    }
                }

                this.setState({ 
                    itemSlider,
                    slider: { start, end },
                }, () => 
                    setTimeout(() => {
                        this.setState({ fadeClass: "fade show"})
                    }, 50)
                );
            }, 300)
        })
    }

}
